// Чистая логика конвейера ККМ-прокси: стадии журнала, backoff пробы,
// дедлайны. Без зависимостей и webpack-алиасов - файл тестируется голым
// `node --test tests/kkm/`. Формат CommonJS, чтобы node запускал его без
// поля "type": "module" в package.json; webpack импортирует его как обычно.

const STAGES = {
  Received: 'received',
  Claimed: 'claimed',
  Sent: 'sent',
  Done: 'done',
  Delivered: 'delivered',
  Abandoned: 'abandoned',
}

const MAX_PROBE_ATTEMPTS = 3
const ABANDON_GRACE_MS = 10 * 60000

function nextProbeDelayMs (attempt) {
  return 2000 * Math.pow(2, attempt)
}

function canRetryProbe (attempt) {
  return attempt < MAX_PROBE_ATTEMPTS
}

function isWithinDeadline (deadlineAt, nowMs = Date.now()) {
  if (!deadlineAt) return true
  return new Date(deadlineAt).getTime() > nowMs
}

function isAbandoned (deadlineAt, nowMs = Date.now()) {
  if (!deadlineAt) return false
  return nowMs > new Date(deadlineAt).getTime() + ABANDON_GRACE_MS
}

function generateClaimerToken () {
  return 'tab-' + Math.random().toString(36).slice(2) + '-' + Date.now().toString(36)
}

module.exports = {
  STAGES,
  MAX_PROBE_ATTEMPTS,
  ABANDON_GRACE_MS,
  nextProbeDelayMs,
  canRetryProbe,
  isWithinDeadline,
  isAbandoned,
  generateClaimerToken,
}
